/* eslint-disable react/prop-types */
// @mui
import { Box, Grid, Paper, Tooltip, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { isAdmin, isBoscCompany } from '../../../utils/share';
// components
import Iconify from '../../../components/iconify/Iconify';
import { TimeEntryModal } from '../../../components/pop-over';
import TimeHistoryDeleteButton from './TimeHistoryDeleteButton';

export default function TimeHistory({ trackerList, fetchTimeline, runningTask, date, projectList, employeeList }) {
  const isRunning =
    runningTask && new Date(runningTask?.TimeTracker?.[0]?.startTime).toDateString() === new Date(date).toDateString();
  const runningStartTime = dayjs(runningTask?.TimeTracker?.[0]?.startTime).format('LTS');
  const runningDiffMilli = new Date() - new Date(runningTask?.TimeTracker?.[0]?.startTime);
  const runningDiffSec = Math.floor(runningDiffMilli / 1000);
  const runningDiffHour = Math.floor(runningDiffMilli / (1000 * 60 * 60));
  const runningDiffMinutes = Math.floor((runningDiffMilli - runningDiffHour * 60 * 60 * 1000) / (1000 * 60));

  return (
    <>
      {trackerList.map((data) => {
        const startTime = dayjs(data?.startTime).format('LTS');
        const stopTime = dayjs(data?.stopTime).format('LTS');
        const diffMilli = new Date(data?.stopTime) - new Date(data?.startTime);
        const diffSec = Math.floor(diffMilli / 1000);
        const diffHour = Math.floor(diffMilli / (1000 * 60 * 60));
        const diffMinutes = Math.floor((diffMilli - diffHour * 60 * 60 * 1000) / (1000 * 60));
        return (
          <Box key={data?.id} sx={{ mt: 2 }}>
            <Paper sx={{ p: 1, bgcolor: '#f5f5f5' }}>
              <Grid container spacing={1}>
                <Grid item xs={3}>
                  <Box>
                    <Box>
                      <Tooltip title="Duration time" placement="top-start">
                        <Typography variant="h6" gutterBottom color="primary" sx={{ cursor: 'pointer' }}>
                          {diffMilli <= 60000 ? `${diffSec}s` : `${diffHour}h ${diffMinutes}m`}
                        </Typography>
                      </Tooltip>
                    </Box>
                    <Box>
                      <Tooltip title="Task started at" placement="top-start">
                        <Typography
                          variant="p"
                          gutterBottom
                          sx={{ cursor: 'pointer', fontSize: { xs: '10px', lg: '13px' } }}
                        >
                          {startTime}
                        </Typography>
                      </Tooltip>
                      <Typography variant="p" gutterBottom sx={{ fontSize: { xs: '10px', lg: '13px' }, m: 1 }}>
                        -
                      </Typography>
                      {data?.stopTime ? (
                        <Tooltip title="Task ended at" placement="top-start">
                          <Typography
                            variant="p"
                            gutterBottom
                            sx={{ cursor: 'pointer', fontSize: { xs: '10px', lg: '13px' } }}
                          >
                            {stopTime}
                          </Typography>
                        </Tooltip>
                      ) : (
                        <Typography
                          variant="p"
                          gutterBottom
                          sx={{ fontSize: { xs: '10px', lg: '13px' }, color: 'red' }}
                        >
                          is working
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Grid>
                <Grid item md={8} sm={7} xs={6}>
                  <Box>
                    <Box>
                      <Tooltip title="Task name" placement="top-start">
                        <Typography variant="h6" gutterBottom sx={{ cursor: 'pointer', textTransform: 'capitalize' }}>
                          {data?.tasks?.taskName}
                        </Typography>
                      </Tooltip>
                    </Box>
                    {data?.tasks?.projects?.clients?.clientName && data?.tasks?.projects?.projectName && (
                      <Box sx={{ display: 'flex' }}>
                        <Tooltip arrow title="Client name" placement="top-start">
                          <Typography
                            variant="p"
                            gutterBottom
                            sx={{
                              cursor: 'pointer',
                              fontSize: { xs: '10px', lg: '13px' },
                              textTransform: 'capitalize',
                            }}
                          >
                            {data?.tasks?.projects?.clients?.clientName}
                          </Typography>
                        </Tooltip>
                        <Iconify icon={'material-symbols:arrow-right-alt-rounded'} style={{ width: '25px' }} />
                        <Tooltip arrow title="Project name" placement="top-start">
                          <Typography
                            variant="p"
                            gutterBottom
                            sx={{
                              cursor: 'pointer',
                              fontSize: { xs: '10px', lg: '13px' },
                              textTransform: 'capitalize',
                            }}
                          >
                            {data?.tasks?.projects?.projectName}
                          </Typography>
                        </Tooltip>
                      </Box>
                    )}
                  </Box>
                </Grid>
                <Grid item md={1} sm={2} xs={3}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-around', height: '100%', alignItems: 'center' }}>
                    {(isAdmin() || !isBoscCompany()) && (
                      <Tooltip title="Edit this time entry" placement="top-start">
                        <TimeEntryModal
                          action="update"
                          taskName={data?.tasks?.taskName}
                          taskId={data?.tasks?.id}
                          projectId={data?.tasks?.projectId}
                          startTime={data?.startTime}
                          stopTime={data?.stopTime}
                          trackerId={data?.id}
                          projectList={projectList}
                          employeeList={employeeList}
                          fetchTimeline={fetchTimeline}
                          userId={data?.tasks?.userId}
                        />
                      </Tooltip>
                    )}
                    <Tooltip title="Delete this time entry" placement="top-start">
                      <TimeHistoryDeleteButton trackerId={data?.id} fetchTimeline={fetchTimeline} />
                    </Tooltip>
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Box>
        );
      })}
      {isRunning && (
        <Box sx={{ mt: 2 }}>
          <Paper sx={{ p: 1, bgcolor: '#f5f5f5' }}>
            <Grid container spacing={1}>
              <Grid item xs={3}>
                <Box>
                  <Box>
                    <Tooltip title="Duration time" placement="top-start">
                      <Typography variant="h6" gutterBottom color="primary" sx={{ cursor: 'pointer' }}>
                        {runningDiffMilli <= 60000
                          ? `${runningDiffSec}s`
                          : `${runningDiffHour}h ${runningDiffMinutes}m`}
                        {/* Diffference dummy */}
                      </Typography>
                    </Tooltip>
                  </Box>
                  <Box>
                    <Tooltip title="Task started at" placement="top-start">
                      <Typography
                        variant="p"
                        gutterBottom
                        sx={{ cursor: 'pointer', fontSize: { xs: '10px', lg: '13px' } }}
                      >
                        {runningStartTime}
                      </Typography>
                    </Tooltip>
                    <Typography variant="p" gutterBottom sx={{ fontSize: { xs: '10px', lg: '13px' }, m: 1 }}>
                      -
                    </Typography>
                    <Typography
                      variant="p"
                      gutterBottom
                      sx={{ fontSize: { xs: '10px', lg: '13px' }, color: 'red', cursor: 'pointer' }}
                    >
                      is working
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item md={8} sm={7} xs={6}>
                <Box>
                  <Box>
                    <Tooltip title="Task name" placement="top-start">
                      <Typography variant="h6" gutterBottom sx={{ cursor: 'pointer' }}>
                        {runningTask?.taskName}
                      </Typography>
                    </Tooltip>
                  </Box>
                  {runningTask?.projects?.clients?.clientName && runningTask?.projects?.projectName && (
                    <Box sx={{ display: 'flex' }}>
                      <Tooltip arrow title="Client name" placement="top-start">
                        <Typography
                          variant="p"
                          gutterBottom
                          sx={{ cursor: 'pointer', fontSize: { xs: '10px', lg: '13px' } }}
                        >
                          {runningTask?.projects?.clients?.clientName}
                        </Typography>
                      </Tooltip>
                      <Iconify icon={'material-symbols:arrow-right-alt-rounded'} style={{ width: '25px' }} />
                      <Tooltip arrow title="Project name" placement="top-start">
                        <Typography
                          variant="p"
                          gutterBottom
                          sx={{ cursor: 'pointer', fontSize: { xs: '10px', lg: '13px' } }}
                        >
                          {runningTask?.projects?.projectName}
                        </Typography>
                      </Tooltip>
                    </Box>
                  )}
                </Box>
              </Grid>
              <Grid item md={1} sm={2} xs={3} />
            </Grid>
          </Paper>
        </Box>
      )}
    </>
  );
}
